import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditCoupon from "../../components/coupons/FormAddEditCoupon";
import { useGetCouponById } from "../../hooks/coupons/useGetCouponById";
import LoadingPage from "../../components/global/LoadingPage";

const EditCoupon = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, coupon } = useGetCouponById(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/coupons");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditCoupon
                isEdit={true}
                currentData={coupon}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditCoupon;
